// utils/confirmationDialog.ts
import { confirmationService } from "./confirmationService";
import { SweetAlertIcon } from "sweetalert2";
import Swal from "sweetalert2";
import { textareaDialogService } from "./textareaDialogService";

export const showConfirmationDialog = async (
  title: string = "Are you sure?",
  text: string = "This action cannot be undone!",
  confirmButtonText: string = "Yes, do it!",
  cancelButtonText: string = "Cancel",
  icon: string = "warning"
): Promise<boolean> => {
  // Use the new custom confirmation modal
  return await confirmationService.show(
    title,
    text,
    confirmButtonText,
    cancelButtonText
  );
};
export const showTextareaDialog = async (
  title: string = "Message",
  inputLabel: string = "Message", // This parameter is not needed anymore but kept for compatibility
  placeholder: string = "Type your message here...",
  confirmButtonText: string = "Submit",
  cancelButtonText: string = "Cancel"
): Promise<string | null> => {
  // Use the new custom textarea modal instead of SweetAlert2
  return await textareaDialogService.show(
    title,
    placeholder,
    confirmButtonText,
    cancelButtonText
  );
};

export const showTextareaDialog1 = async (
  title: string = "Message",
  inputLabel: string = "Message",
  placeholder: string = "Type your message here...",
  confirmButtonText: string = "Submit",
  cancelButtonText: string = "Cancel"
): Promise<string | null> => {
  const { value: text } = await Swal.fire({
    title,
    input: "textarea",
    inputLabel,
    inputPlaceholder: placeholder,
    inputAttributes: {
      "aria-label": placeholder,
    },
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    icon: "warning",
    // ❌ Prevent closing by clicking outside
    allowOutsideClick: false,

    // ❌ Prevent submitting if empty
    inputValidator: (value) => {
      if (!value || value.trim().length === 0) {
        return "Please enter a message before submitting.";
      }
      return null;
    },
  });

  return text ?? null;
};

export const showOkDialog = async (
  title: string = "",
  text: string = "",
  icon: SweetAlertIcon = "success"
): Promise<void> => {
  await Swal.fire({
    title,
    text,
    icon,
    confirmButtonText: "OK",
    customClass: {
      popup: "okConfirmationDialog",
      confirmButton: "okConfirmationDialog__confirm",
    },
  });
};
